<template>
  <div class="splash fixed inset-0 z-[60] flex items-center justify-center overflow-hidden bg-white">
    <!-- Soft cream glow behind the mark -->
    <div class="pointer-events-none absolute left-1/2 top-1/2 h-[520px] w-[520px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-brand-cream/50 blur-3xl"></div>

    <div class="relative flex flex-col items-center px-6 text-center">
      <!-- Emblem: GSAP scales it in, CSS keeps it slowly turning -->
      <div ref="emblem">
        <img
          :src="emblemImage"
          alt="Jaapi emblem"
          class="rotate-slow h-20 w-20 md:h-24 md:w-24 drop-shadow-md"
        />
      </div>

      <!-- Title and subtitle fade and rise in. No clipping box: Assamese vowel signs (ি, ী, ৃ)
           reach well above and below the line, so a clipped box cuts them off. -->
      <div class="mt-6 px-2">
        <h1 ref="title" class="font-serif text-4xl font-bold leading-normal text-brand-red md:text-6xl md:leading-normal">
          সাংস্কৃতিক দাপোণ
        </h1>
      </div>
      <div>
        <p ref="subtitle" class="text-xs font-medium uppercase tracking-[0.3em] text-gray-500 md:text-sm">
          Cultural Magazine Dapon
        </p>
      </div>

      <!-- Progress line -->
      <div class="mt-9 h-[2px] w-48 overflow-hidden bg-gray-100 md:w-56">
        <div ref="line" class="h-full w-full origin-left bg-brand-red"></div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from "vue";
import gsap from "gsap";
import emblemImage from "@/assets/images/japi2.png";

const emblem = ref(null);
const title = ref(null);
const subtitle = ref(null);
const line = ref(null);
let tl;

onMounted(() => {
  if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

  tl = gsap.timeline({ defaults: { ease: "power3.out" } });
  tl.from(emblem.value, { scale: 0.5, opacity: 0, duration: 0.7 })
    .from(title.value, { y: 26, opacity: 0, filter: "blur(6px)", duration: 0.8 }, "-=0.35")
    .from(subtitle.value, { y: 14, opacity: 0, duration: 0.6 }, "-=0.45")
    .from(line.value, { scaleX: 0, duration: 1.2, ease: "power2.inOut" }, 0.15);
});

onBeforeUnmount(() => {
  if (tl) tl.kill();
});
</script>

<style scoped>
@keyframes rotateSlow {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.rotate-slow {
  animation: rotateSlow 14s linear infinite;
}

@media (prefers-reduced-motion: reduce) {
  .rotate-slow {
    animation: none;
  }
}
</style>
